module.exports = "/images/sala_viajero_z02.jpg?a63046fdf0b50161e2f0955e4d6df8ed";